import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Raven from 'raven-js';
import { useDeleteStagedPageMutation } from 'ContentEditorUI/__generated__/chirp/com/hubspot/contentstaging/rpc/ContentStagingPagesRpc.hooks';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import redirectToNewUrl from 'ContentEditorUI/utils/contentManagementPanel/redirectToNewUrl';
import { getStagingDashboardUrl } from '../redux/selectors/urlSelectors';
import { CONTENT_MANAGEMENT_ACTION } from 'ContentEditorUI/constants/contentManagement';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { getContentTypeForUsageTracker } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const useStagingV2Delete = () => {
  const [deleteStagedPage] = useDeleteStagedPageMutation();
  const stagingDashboardUrl = useSelector(getStagingDashboardUrl);
  const deleteStagedContent = useCallback(page => {
    const usageTrackingKey = `delete-staged-${getContentTypeForUsageTracker(page.categoryId)}`;
    void deleteStagedPage({
      variables: {
        contentId: page.id
      }
    }).then(() => {
      UsageTracker.trackEditorInteraction({
        action: CONTENT_MANAGEMENT_ACTION,
        event: `${usageTrackingKey}-success`
      });
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentStaging.delete.alerts.success.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentStaging.delete.alerts.success.body"
        }),
        type: 'success'
      });
      // Redirect to content staging after successful deletion
      redirectToNewUrl(stagingDashboardUrl);
    }).catch(error => {
      UsageTracker.trackEditorInteraction({
        action: CONTENT_MANAGEMENT_ACTION,
        event: `${usageTrackingKey}-failed`
      });
      const errorToLog = error instanceof Error ? error : new Error('page-editor-ui: useStagingV2Delete: Failed to delete staged page', {
        cause: error
      });
      Raven.captureException(errorToLog);
      FloatingAlertStore.addAlert({
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentStaging.delete.alerts.error.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentStaging.delete.alerts.error.body"
        }),
        type: 'danger'
      });
    });
  }, [deleteStagedPage, stagingDashboardUrl]);
  return {
    deleteStagedContent
  };
};
export default useStagingV2Delete;